import { Component, OnInit } from '@angular/core';
import { GlobalConfig } from '../../entities';
import { Subject } from 'rxjs/Subject';
import { HttpserviceService } from '../../service/http.service.service';

@Component({
  selector: 'app-view',
  templateUrl: './view.component.html',
  styleUrls: ['./view.component.css']
})
export class ViewComponent implements OnInit {
  subject: Subject<boolean>;
  agentId: any = '';
  apiUrl: any = '';
  agent: any[] = [];
  constructor(
    private servicesComponent: HttpserviceService,
    private config: GlobalConfig)
  { }

  ngOnInit() {
    this.apiUrl = this.config.apiRootUrl;
    this.agentId = this.config.confirmService.confirmMessage;
    this.config.confirmService = { confirmMessage: '' };
    this.getDetail();
  }

  getDetail() {
    this.servicesComponent.getAgentDetail(this.agentId)
      .then((response: any) => {
        if (response.success) {
          this.agent = response.receiveObj; 
        }
      })
  }
  conformMessge(confirm: boolean) {
    this.subject.next(confirm);
    this.subject.complete();
  }
}



// WEBPACK FOOTER //
// D:/Projects/Web/Dubai/DubaisaleV1/cpapi.v1/CPDubaisaleApp/src/app/agentManagement/view/view.component.ts